export default "__VITE_ASSET__CKc48ffY__"